var _rect, _rect2, _rect3, _g, _path, _path2, _path3, _g2, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g3, _path5, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleDataSourcesSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 142,
    viewBox: "0 0 289 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2465_28917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 283,
    height: 136
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 283,
    height: 136,
    rx: 8,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2465_28917)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 856,
    height: 703,
    transform: "translate(-284 -311)",
    fill: "#020409"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2465_28917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -284,
    y: -311,
    width: 856,
    height: 703
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -284,
    y: -311,
    width: 856,
    height: 703,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2465_28917)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572 8.00021L-284 8.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 24.0002L-284 24.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 40.0002L-284 40.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 56.0002L-284 56.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 72.0002L-284 72.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 88.0002L-284 88.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 104L-284 104",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 120L-284 120",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 136L-284 136",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 45.3333C31.5272 45.3333 30.3333 46.5272 30.3333 48C30.3333 49.4728 31.5272 50.6667 33 50.6667C34.4728 50.6667 35.6667 49.4728 35.6667 48C35.6667 46.5272 34.4728 45.3333 33 45.3333ZM33 59.3333C31.5272 59.3333 30.3333 60.5272 30.3333 62C30.3333 63.4728 31.5272 64.6667 33 64.6667C34.4728 64.6667 35.6667 63.4728 35.6667 62C35.6667 60.5272 34.4728 59.3333 33 59.3333ZM32.5 48L32.5 62L33.5 62L33.5 48L32.5 48Z",
    fill: "#7E858F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6667 88C52.6667 86.5272 51.4728 85.3333 50 85.3333C48.5272 85.3333 47.3333 86.5272 47.3333 88C47.3333 89.4728 48.5272 90.6667 50 90.6667C51.4728 90.6667 52.6667 89.4728 52.6667 88ZM79 87.5H50V88.5H79V87.5Z",
    fill: "#7E858F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6667 78C79.6667 76.5272 78.4728 75.3333 77 75.3333C75.5272 75.3333 74.3333 76.5272 74.3333 78C74.3333 79.4728 75.5272 80.6667 77 80.6667C78.4728 80.6667 79.6667 79.4728 79.6667 78ZM77 77.5L50 77.5L50 78.5L77 78.5L77 77.5Z",
    fill: "#7E858F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2465_28917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3432 24H22.8762C22.3535 24.0275 21.863 24.2607 21.5119 24.6488C21.1607 25.0369 20.9775 25.5482 21.0022 26.071V38.5978C20.9775 39.1205 21.1607 39.6319 21.5119 40.0199C21.863 40.408 22.3535 40.6413 22.8762 40.6687H33.63V39.6585H22.8762C22.6254 39.6222 22.3975 39.493 22.2375 39.2966C22.0775 39.1001 21.9972 38.8507 22.0124 38.5978V30.0614H31.1045V37.638C31.1045 37.772 31.1577 37.9005 31.2524 37.9952C31.3471 38.0899 31.4756 38.1432 31.6096 38.1432H35.6505V37.1329H32.342V36.9814C32.3407 36.1383 32.6119 35.3173 33.1153 34.641C33.6187 33.9646 34.3273 33.4691 35.1353 33.2284C35.5252 33.4069 35.949 33.4993 36.3779 33.4993C36.8067 33.4993 37.2305 33.4069 37.6204 33.2284C38.552 33.5096 39.347 34.1247 39.853 34.9559L40.7117 34.4508C40.1917 33.6018 39.4277 32.9293 38.5195 32.5213C38.9339 32.0293 39.1612 31.4067 39.161 30.7635C39.161 30.0267 38.8683 29.32 38.3473 28.799C37.8263 28.278 37.1197 27.9853 36.3829 27.9853C35.6461 27.9853 34.9395 28.278 34.4185 28.799C33.8975 29.32 33.6048 30.0267 33.6048 30.7635C33.618 31.3962 33.85 32.0049 34.2614 32.4859C33.3872 32.8736 32.6461 33.5094 32.1299 34.3144V27.5358H40.7168V34.4558V34.6074H41.727V30.0614H43.2423V35.1125H44.2526V26.071C44.2648 25.8092 44.2249 25.5477 44.1352 25.3015C44.0456 25.0553 43.908 24.8293 43.7304 24.6367C43.5528 24.4441 43.3388 24.2886 43.1006 24.1793C42.8625 24.07 42.6051 24.0091 42.3432 24ZM36.3829 28.9855C36.6137 28.9841 36.8426 29.0283 37.0564 29.1154C37.2701 29.2025 37.4647 29.3309 37.6288 29.4932C37.793 29.6554 37.9236 29.8485 38.0131 30.0612C38.1027 30.274 38.1495 30.5023 38.1508 30.7332C38.1487 31.0446 38.0626 31.3497 37.9018 31.6164C37.7409 31.883 37.5111 32.1014 37.2365 32.2485C36.9735 32.3904 36.6793 32.4647 36.3804 32.4647C36.0815 32.4647 35.7873 32.3904 35.5242 32.2485C35.251 32.1003 35.0225 31.8816 34.8626 31.615C34.7027 31.3485 34.6172 31.044 34.615 30.7332C34.6163 30.5023 34.6631 30.274 34.7527 30.0612C34.8422 29.8485 34.9728 29.6554 35.137 29.4932C35.3012 29.3309 35.4957 29.2025 35.7095 29.1154C35.9232 29.0283 36.1521 28.9841 36.3829 28.9855ZM41.7118 29.0511V27.0307C41.7118 26.8967 41.6586 26.7682 41.5639 26.6735C41.4692 26.5788 41.3407 26.5256 41.2067 26.5256H31.6096C31.4756 26.5256 31.3471 26.5788 31.2524 26.6735C31.1577 26.7682 31.1045 26.8967 31.1045 27.0307V29.0511H22.0124V26.071C21.9972 25.8181 22.0775 25.5686 22.2375 25.3722C22.3975 25.1757 22.6254 25.0465 22.8762 25.0102H42.3432C42.5958 25.0442 42.8263 25.1724 42.9883 25.3691C43.1504 25.5658 43.2321 25.8165 43.2171 26.071V29.0511H41.7118Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5789 32.5617H23.0327V33.5719H28.5789V32.5617Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5584 35.0873H23.0327V36.0975H26.5584V35.0873Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.084 35.0873H27.5787V36.0975H29.084V35.0873Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8986 46.7554C40.1999 46.7587 39.508 46.6187 38.8656 46.3439C38.2232 46.0691 37.6441 45.6654 37.164 45.1577C36.6839 44.6501 36.3131 44.0494 36.0745 43.3927C35.8359 42.736 35.7346 42.0374 35.7768 41.34C35.819 40.6426 36.004 39.9612 36.3201 39.3382C36.6362 38.7151 37.0768 38.1635 37.6147 37.7176C38.1525 37.2716 38.7762 36.9408 39.447 36.7455C40.1179 36.5503 40.8217 36.4947 41.5148 36.5824C42.431 36.6956 43.2994 37.0547 44.0279 37.6217C44.7564 38.1887 45.3177 38.9424 45.6524 39.8027C45.987 40.6631 46.0823 41.598 45.9284 42.5082C45.7744 43.4184 45.3768 44.2699 44.7779 44.9723C44.3049 45.5166 43.7256 45.9583 43.0756 46.2705C42.3941 46.5893 41.651 46.7548 40.8986 46.7554ZM40.8986 37.5522C40.2498 37.5519 39.6105 37.7079 39.0347 38.0068C38.0839 38.5003 37.3641 39.3466 37.0298 40.3643C36.6954 41.3821 36.7731 42.4904 37.2461 43.4516C37.7191 44.4128 38.5498 45.1504 39.5602 45.5065C40.5706 45.8625 41.6802 45.8086 42.6513 45.3562C43.1759 45.1075 43.6422 44.7512 44.0202 44.3106C44.5016 43.7473 44.8212 43.064 44.9449 42.3335C45.0687 41.6029 44.992 40.8524 44.723 40.162C44.454 39.4716 44.0027 38.8671 43.4173 38.4128C42.8319 37.9586 42.1343 37.6716 41.3987 37.5825C41.2294 37.562 41.059 37.5518 40.8885 37.5522H40.8986Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0955 43.8004C40.029 43.8008 39.9631 43.788 39.9016 43.7629C39.84 43.7378 39.7841 43.7007 39.7369 43.6539L38.1053 42.0224L38.8075 41.3102L40.0803 42.5831L42.9595 39.6989L43.6767 40.4161L40.4339 43.6539C40.3436 43.7436 40.2227 43.796 40.0955 43.8004Z",
    fill: "#7E858F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5556 93.975C31.6279 93.9743 29.7317 93.4855 28.0439 92.5541L28.5496 91.6692C30.5743 92.7774 32.9086 93.1849 35.189 92.8283C37.4694 92.4716 39.5679 91.3709 41.1576 89.6975C42.7474 88.0241 43.7391 85.872 43.9784 83.5763C44.2176 81.2806 43.691 78.9702 42.4806 77.005L41.9749 79.5333L40.9636 79.3361L41.6968 75.6549C41.7225 75.5235 41.7992 75.4078 41.9101 75.3329C42.021 75.258 42.157 75.2301 42.2884 75.2554L46 75.9886L45.8028 76.9999L43.325 76.4943C44.3882 78.2334 44.9695 80.2241 45.0093 82.262C45.0491 84.3 44.546 86.3118 43.5516 88.0912C42.5572 89.8705 41.1073 91.3532 39.3507 92.3872C37.594 93.4212 35.594 93.9692 33.5556 93.975ZM24.7925 89.5657C24.7505 89.5706 24.7081 89.5706 24.6661 89.5657L21 88.6453L21.2478 87.6644L23.6042 88.256C22.3403 86.09 21.8209 83.5696 22.1254 81.0804C22.4299 78.5912 23.5415 76.2703 25.2902 74.4728C27.0389 72.6754 29.3284 71.5003 31.8083 71.1275C34.2882 70.7547 36.8219 71.2046 39.0218 72.4085L38.5162 73.2934C36.4992 72.2018 34.1794 71.8032 31.9137 72.1589C29.648 72.5146 27.562 73.605 25.9766 75.2622C24.3912 76.9195 23.3942 79.0517 23.1392 81.331C22.8841 83.6102 23.3851 85.9101 24.5649 87.8767L25.2223 85.2625L26.2033 85.5052L25.283 89.1712C25.2578 89.2827 25.1956 89.3824 25.1066 89.4541C25.0175 89.5257 24.9068 89.565 24.7925 89.5657ZM37.5554 87.3862C37.1073 87.3859 36.6719 87.2367 36.3177 86.9622C35.9635 86.6876 35.7105 86.3032 35.5985 85.8693H31.4268C31.3322 86.2354 31.137 86.5677 30.8631 86.8285C30.5892 87.0892 30.2477 87.268 29.8774 87.3444C29.507 87.4209 29.1227 87.392 28.7679 87.2611C28.4132 87.1301 28.1022 86.9024 27.8704 86.6036C27.6386 86.3049 27.4951 85.9471 27.4564 85.5709C27.4176 85.1948 27.4851 84.8153 27.6511 84.4755C27.8171 84.1358 28.0751 83.8494 28.3957 83.6488C28.7163 83.4483 29.0867 83.3416 29.4648 83.3409C29.6491 83.3407 29.8327 83.3645 30.0109 83.4117L32.1246 79.7507C31.8307 79.4725 31.627 79.1124 31.5399 78.7171C31.4528 78.3219 31.4863 77.9095 31.6361 77.5335C31.7858 77.1575 32.045 76.835 32.38 76.6079C32.715 76.3807 33.1104 76.2593 33.5152 76.2593C33.9199 76.2593 34.3154 76.3807 34.6504 76.6079C34.9854 76.835 35.2445 77.1575 35.3943 77.5335C35.544 77.9095 35.5775 78.3219 35.4904 78.7171C35.4034 79.1124 35.1997 79.4725 34.9057 79.7507L37.0194 83.4117C37.1943 83.3652 37.3745 83.3414 37.5554 83.3409C38.0919 83.3409 38.6063 83.554 38.9857 83.9334C39.365 84.3127 39.5781 84.8271 39.5781 85.3636C39.5781 85.9 39.365 86.4145 38.9857 86.7938C38.6063 87.1731 38.0919 87.3862 37.5554 87.3862ZM37.5554 84.3523C37.3554 84.3523 37.1599 84.4116 36.9936 84.5227C36.8272 84.6338 36.6976 84.7918 36.6211 84.9766C36.5445 85.1614 36.5245 85.3647 36.5635 85.5609C36.6025 85.7571 36.6989 85.9373 36.8403 86.0787C36.9817 86.2201 37.1619 86.3165 37.3581 86.3555C37.5543 86.3945 37.7576 86.3745 37.9424 86.2979C38.1272 86.2214 38.2852 86.0918 38.3963 85.9255C38.5074 85.7591 38.5667 85.5636 38.5667 85.3636C38.5667 85.0954 38.4602 84.8381 38.2705 84.6485C38.0809 84.4588 37.8236 84.3523 37.5554 84.3523ZM29.4648 84.3523C29.2648 84.3523 29.0693 84.4116 28.9029 84.5227C28.7366 84.6338 28.607 84.7918 28.5305 84.9766C28.4539 85.1614 28.4339 85.3647 28.4729 85.5609C28.5119 85.7571 28.6083 85.9373 28.7497 86.0787C28.8911 86.2201 29.0713 86.3165 29.2675 86.3555C29.4637 86.3945 29.667 86.3745 29.8518 86.2979C30.0366 86.2214 30.1946 86.0918 30.3057 85.9255C30.4168 85.7591 30.4761 85.5636 30.4761 85.3636C30.4761 85.2308 30.45 85.0993 30.3991 84.9766C30.3483 84.8539 30.2738 84.7424 30.1799 84.6485C30.086 84.5546 29.9745 84.4801 29.8518 84.4292C29.7291 84.3784 29.5976 84.3523 29.4648 84.3523ZM31.4268 84.8579H35.5985C35.6904 84.4986 35.8793 84.1715 36.1446 83.9123L34.0208 80.2362C33.6892 80.3218 33.3412 80.3218 33.0095 80.2362L30.8908 83.9174C31.1524 84.1778 31.3377 84.5048 31.4268 84.863V84.8579ZM33.5101 77.273C33.3101 77.273 33.1146 77.3323 32.9482 77.4434C32.7819 77.5545 32.6523 77.7125 32.5758 77.8973C32.4992 78.0821 32.4792 78.2854 32.5182 78.4816C32.5572 78.6778 32.6536 78.858 32.795 78.9994C32.9364 79.1409 33.1166 79.2372 33.3128 79.2762C33.509 79.3152 33.7123 79.2952 33.8971 79.2186C34.0819 79.1421 34.2399 79.0125 34.351 78.8462C34.4621 78.6799 34.5214 78.4843 34.5214 78.2843C34.5214 78.0161 34.4149 77.7588 34.2252 77.5692C34.0356 77.3795 33.7783 77.273 33.5101 77.273Z",
    fill: "#7E858F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 52.5,
    width: 90,
    height: 66,
    rx: 3.5,
    fill: "#020409",
    stroke: "#7E858F",
    strokeDasharray: "2 2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 46.5,
    width: 89,
    height: 67,
    rx: 3.5,
    fill: "#020409",
    stroke: "#7E858F",
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 41.5,
    width: 89,
    height: 67,
    rx: 3.5,
    fill: "#020409",
    stroke: "#7E858F",
    strokeDasharray: "2 2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 36.5,
    width: 89,
    height: 66,
    rx: 3.5,
    fill: "#020409",
    stroke: "#7E858F",
    strokeDasharray: "2 2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9528,
    y: 72.4449,
    width: 70.2362,
    height: 15.9921,
    rx: 3.5,
    stroke: "#2B2D31"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9528,
    y: 50.8779,
    width: 69.5827,
    height: 15.9921,
    rx: 3.5,
    stroke: "#2B2D31"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2465_28917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.016 70.0212L258.708 73.3239C259.303 73.1579 259.877 72.9245 260.42 72.6283C260.578 72.7266 260.713 72.8579 260.816 73.0134C260.919 73.1689 260.987 73.3448 261.015 73.529C261.015 74.4448 259.073 75.4406 256.191 75.8459C255.302 75.9661 254.406 76.0296 253.509 76.036H253.009C248.965 75.941 246.003 74.6649 246.003 73.534C246.031 73.3498 246.099 73.1739 246.202 73.0184C246.305 72.8629 246.44 72.7316 246.598 72.6333C248.17 73.509 250.717 74.0294 253.509 74.0294H253.564L253.844 73.0286C253.734 73.0286 253.624 73.0286 253.509 73.0286C250.757 73.0286 248.205 72.4832 246.849 71.6225C246.308 71.2672 246.008 70.8819 246.003 70.5466V68.2298C247.534 69.4007 250.587 70.0112 253.509 70.0112C253.904 70.0112 254.3 70.0112 254.685 69.9762L254.97 68.9754C254.47 69.0104 254.004 69.0254 253.509 69.0254C249.216 69.0254 246.003 67.7094 246.003 66.5234C246.031 66.3392 246.099 66.1633 246.202 66.0078C246.305 65.8523 246.44 65.7209 246.598 65.6227C247.98 66.3983 250.101 66.8837 252.508 66.9938L252.533 65.993C250.166 65.8779 248.03 65.3675 246.849 64.6119C246.313 64.2666 246.013 63.8763 246.003 63.536V61.2242C247.534 62.3951 250.587 63.0056 253.509 63.0056H253.619L254.15 62.0048H253.509C249.216 62.0048 246.003 60.6888 246.003 59.5028C246.003 58.3169 249.216 57.0008 253.509 57.0008C254.955 56.9947 256.397 57.1627 257.802 57.5012H260.55C259.048 56.5855 256.456 56 253.509 56C249.386 56 245.002 57.221 245.002 59.5028V63.531C245.017 63.8164 245.092 64.0954 245.223 64.3497C245.353 64.6041 245.535 64.8281 245.758 65.0072C245.532 65.1893 245.348 65.4173 245.218 65.6762C245.088 65.9351 245.014 66.2188 245.002 66.5084V70.5116C245.014 70.8013 245.087 71.0851 245.218 71.344C245.348 71.6029 245.532 71.831 245.758 72.0128C245.532 72.1949 245.348 72.423 245.218 72.6818C245.088 72.9407 245.014 73.2244 245.002 73.514V77.5172C244.999 77.5522 244.999 77.5873 245.002 77.6223C245.137 79.8191 249.441 81 253.509 81C257.577 81 261.881 79.8191 262.016 77.6123C262.021 77.5774 262.021 77.5421 262.016 77.5072V73.504C262.006 73.214 261.934 72.9295 261.803 72.6703C261.673 72.411 261.487 72.1833 261.26 72.0028C261.486 71.821 261.67 71.5929 261.801 71.334C261.931 71.0751 262.004 70.7912 262.016 70.5016V70.0212ZM261.015 77.5272C261.015 78.7082 257.802 80.0292 253.509 80.0292C249.216 80.0292 246.003 78.7232 246.003 77.5272V75.2254C247.534 76.3863 250.587 76.9968 253.509 76.9968C256.431 76.9968 259.484 76.3863 261.015 75.2254V77.5272Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.504 64.1615C247.85 64.1615 248.13 63.8815 248.13 63.536C248.13 63.1906 247.85 62.9105 247.504 62.9105C247.159 62.9105 246.879 63.1906 246.879 63.536C246.879 63.8815 247.159 64.1615 247.504 64.1615Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.504 71.1672C247.85 71.1672 248.13 70.8871 248.13 70.5417C248.13 70.1962 247.85 69.9162 247.504 69.9162C247.159 69.9162 246.879 70.1962 246.879 70.5417C246.879 70.8871 247.159 71.1672 247.504 71.1672Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.504 78.1727C247.85 78.1727 248.13 77.8926 248.13 77.5472C248.13 77.2017 247.85 76.9217 247.504 76.9217C247.159 76.9217 246.879 77.2017 246.879 77.5472C246.879 77.8926 247.159 78.1727 247.504 78.1727Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76 75.5256C254.672 75.5247 254.586 75.5005 254.51 75.4555C254.412 75.3994 254.337 75.3121 254.295 75.2077C254.253 75.1033 254.248 74.9879 254.28 74.8801L257.092 65.5176H254.26C254.172 65.5187 254.086 65.4969 254.01 65.4543C253.933 65.4118 253.869 65.35 253.824 65.2751C253.779 65.2002 253.755 65.1148 253.753 65.0274C253.751 64.94 253.772 64.8537 253.814 64.777L256.817 58.7722C256.858 58.6897 256.922 58.6203 257 58.5717C257.079 58.5231 257.17 58.4972 257.262 58.497H263.767C263.848 58.4929 263.929 58.5087 264.003 58.5428C264.076 58.577 264.141 58.6286 264.19 58.6931C264.239 58.7576 264.272 58.8332 264.285 58.9132C264.299 58.9932 264.293 59.0753 264.268 59.1525L262.987 63.0006H265.794C265.892 63.0009 265.987 63.0299 266.069 63.084C266.15 63.1381 266.214 63.2149 266.252 63.3048C266.291 63.3948 266.302 63.494 266.284 63.5902C266.267 63.6865 266.222 63.7755 266.154 63.8462L255.145 75.3554C255.097 75.4101 255.038 75.4536 254.971 75.483C254.905 75.5124 254.833 75.5269 254.76 75.5256ZM255.07 64.5168H257.762C257.84 64.5168 257.917 64.5349 257.986 64.5696C258.056 64.6043 258.116 64.6548 258.163 64.7169C258.209 64.7791 258.241 64.8512 258.255 64.9277C258.269 65.0041 258.265 65.0827 258.243 65.1573L255.836 73.1637L264.598 64.0064H262.266C262.184 64.0107 262.103 63.995 262.029 63.9605C261.955 63.9261 261.89 63.874 261.841 63.8088C261.791 63.7437 261.759 63.6674 261.745 63.5867C261.732 63.5059 261.739 63.4233 261.766 63.3458L263.047 59.5028H257.542L255.07 64.5168Z",
    fill: "#7E858F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.333 70C188.333 71.4728 189.527 72.6667 191 72.6667C192.473 72.6667 193.667 71.4728 193.667 70C193.667 68.5272 192.473 67.3333 191 67.3333C189.527 67.3333 188.333 68.5272 188.333 70ZM237.333 70C237.333 71.4728 238.527 72.6667 240 72.6667C241.473 72.6667 242.667 71.4728 242.667 70C242.667 68.5272 241.473 67.3333 240 67.3333C238.527 67.3333 237.333 68.5272 237.333 70ZM191 70.5L240 70.5L240 69.5L191 69.5L191 70.5Z",
    fill: "#7E858F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 286,
    height: 139,
    rx: 9.5,
    stroke: "#2B2D31",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2465_28917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(21 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2465_28917"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 56,
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleDataSourcesSmall);
export default __webpack_public_path__ + "static/media/single-data-sources-small.004f52d5a61fde2870bb6662fc2a583b.svg";
export { ForwardRef as ReactComponent };